import { useState } from "react";
import { Link as LinkIcon, Check } from "lucide-react";

const Btn = ({ children, onClick, href, bg, fg = "#FFFFFF", testId, primary }) => {
  const cls = `inline-flex items-center gap-1.5 rounded-full transition-all hover:-translate-y-[1px] ${
    primary ? "px-4 py-2 text-[13px] font-medium" : "px-3 py-1.5 text-[12px]"
  }`;
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
        style={{ background: bg, color: fg }}
        data-testid={testId}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      className={cls}
      style={{ background: bg, color: fg }}
      data-testid={testId}
    >
      {children}
    </button>
  );
};

export const ShareButtons = ({ headline, pageUrl, shareUrl }) => {
  const [copied, setCopied] = useState(false);
  const enc = (s) => encodeURIComponent(s);
  // `shareUrl` (if provided) is the URL that crawlers should hit for rich
  // previews (points at the backend OG endpoint). Everything shared to
  // WhatsApp/X and the copy-link button uses it. Falls back to `pageUrl`
  // when a caller doesn't provide one.
  const socialUrl = shareUrl || pageUrl;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(socialUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  const waUrl = `https://wa.me/?text=${enc(headline)}%20-%20${enc(socialUrl)}`;
  const xUrl = `https://twitter.com/intent/tweet?text=${enc(
    headline
  )}&url=${enc(socialUrl)}&via=IslandsDaily`;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <Btn href={waUrl} bg="#25D366" testId="share-whatsapp" primary>
        <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
          <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.819 11.819 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892-.001 0 .001 0 0 0a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.51 5.26l.6.952-1.034 3.776 3.413-.787z" />
        </svg>
        Share on WhatsApp
      </Btn>
      <Btn onClick={onCopy} bg="#0AADA0" testId="share-copy">
        {copied ? (
          <>
            <Check size={12} /> Copied!
          </>
        ) : (
          <>
            <LinkIcon size={12} /> Copy Link
          </>
        )}
      </Btn>
      <Btn href={xUrl} bg="#1A2E35" testId="share-x">
        <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
        </svg>
        Share on X
      </Btn>
    </div>
  );
};
